module.exports = __webpack_public_path__ + "static/img/1.5f3152d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting811/images/1.png
// module id = DycJ
// module chunks = 4